import { useCallback, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { LANGUAGE_KEYS } from 'config/languageKeys';

import { AppNotification } from 'components/Notification/types';

const {
    TIMESHIFT_START_NOTIFICATION_TITLE,
    TIMESHIFT_START_NOTIFICATION_BODY,
} = LANGUAGE_KEYS;

/* useTimeshiftNotifications */
function useTimeshiftNotifications() {
    const { t } = useTranslation();

    const [timeshiftNotification, setTimeshiftNotification] = useState<
        AppNotification | undefined
    >();
    const [timeshiftNotificationShown, setTimeshiftNotificationShown] =
        useState(false);

    const handleSetTimeshiftNotification = useCallback(() => {
        if (!timeshiftNotificationShown) {
            setTimeshiftNotification({
                title: t(TIMESHIFT_START_NOTIFICATION_TITLE),
                description: t(TIMESHIFT_START_NOTIFICATION_BODY),
            });
        }
    }, [t, timeshiftNotificationShown]);

    const handleResetTimeshiftNotification = useCallback(() => {
        setTimeshiftNotification(undefined);
    }, []);

    const handleResetTimeshiftNotificationShown = useCallback(() => {
        setTimeshiftNotificationShown(false);
    }, []);

    useEffect(() => {
        if (timeshiftNotification) {
            setTimeshiftNotificationShown(true);
        }
    }, [timeshiftNotification]);

    return {
        timeshiftNotification,
        onSetTimeshiftNotification: handleSetTimeshiftNotification,
        onResetTimeshiftNotification: handleResetTimeshiftNotification,
        onResetTimeshiftNotificationShown:
            handleResetTimeshiftNotificationShown,
    };
}

export default useTimeshiftNotifications;
